module.exports = __webpack_public_path__ + "img/garden.5ed8b83e.svg";